<div class="column right extra-space">
  <div class="utils-buttons-wrapper">
    <app-utils-buttons (userLangChanged)="userLangChanged.emit($event)"></app-utils-buttons>
  </div>

  <div class="content-column extra-space">
    <div class="form-title error-title">
      {{ 'COMMON.ERROR.NO_CONNECTION_WITH_SERVER' | translate }}
    </div>

    <div class="connection-error-block">
      <div class="subtitle" [innerHTML]="'COMMON.ERROR.CONNECTION_ERROR_EXPLANATION' | translate"></div>
      <ul>
        <li [innerHTML]="'COMMON.NOTIFICATION.WAIT_WE_WILL_TRY_TO_RECONNECT' | translate"></li>
        <li [innerHTML]="'COMMON.NOTIFICATION.CHECK_INTERNET_CONNECTION' | translate"></li>
        <li [innerHTML]="'COMMON.NOTIFICATION.CHECK_FIREWALL_SETTINGS' | translate"></li>
        <li [innerHTML]="'COMMON.NOTIFICATION.CONSULT_LOCAL_NETWORK_ADMIN' | translate"></li>
        <li [innerHTML]="'COMMON.NOTIFICATION.COMEBACK_LATER' | translate"></li>
      </ul>
    </div>
  </div>
</div>
